import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HospitalAddOnService } from '../services/hospital-add-on.service';

export const ipdFeatureGuard: CanActivateFn = () => {
  const addOns = inject(HospitalAddOnService);
  const router = inject(Router);

  if (addOns.isIpdEnabled) {
    return true;
  }

  router.navigate(['/patient']);
  return false;
};
